export function GettingStartedDocs() {
    return (
      <div>
        <h2 className="fw-bold text-dark">Getting Started</h2>
        <p className="text-muted">Follow these 3 simple steps to start sending WhatsApp messages via API.</p>
        
        <div className="row mt-4">
          <StepCard 
            number="1" 
            title="Connect Device" 
            desc="Go to 'WhatsApp' menu and scan the QR code to link your instance." 
          />
          <StepCard 
            number="2" 
            title="Get API Key" 
            desc="Navigate to 'My Apps' to generate your unique Authorization Token." 
          />
          <StepCard 
            number="3" 
            title="Send Message" 
            desc="Use the Sandbox or our cURL examples to trigger your first message." 
          />
        </div>
      </div>
    );
  }
  
  function StepCard({ number, title, desc }) {
    return (
      <div className="col-md-4 mb-3">
        <div className="p-4 rounded-4 bg-light h-100 border border-2 border-white">
          <div className="h1 fw-bold text-primary opacity-25 mb-0">{number}</div>
          <h6 className="fw-bold">{title}</h6>
          <p className="small text-muted mb-0">{desc}</p>
        </div>
      </div>
    );
  }